<template>
  <div>
    <el-row class="cs-search-conditions">
      <el-col :span="4">
        <el-select placeholder="课程类型" size="medium" :disabled="loading" v-model="searchCondition.courseType" @change="onCourseTypeChange">
          <el-option v-for="item in scPreloadData.courseTypeItems" :key="item.value" :label="item.desc" :value="item.value" />
        </el-select>
      </el-col>
      <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.university">
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学校" size="medium" :disabled="loading" v-model="searchCondition.groupNumber" @change="onGroupNumberChange">
            <el-option v-for="item in scPreloadData.universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.termId" @change="onTermIdChange">
            <el-option v-for="item in scPreloadData.termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
          </el-select>
        </el-col>
      </div>
      <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining">
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="职业类型" size="medium" :disabled="loading" v-model="searchCondition.trainingCourseCategory" @change="onTrainingCourseCategoryChange">
            <el-option v-for="item in scPreloadData.trainingCourseCategories" :key="item.Id" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select class="margin-left-20px" placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.trainingTermId" @change="onTrainingTermIdChange">
            <el-option v-for="item in trainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
          </el-select>
        </el-col>
      </div>
      <el-col :span="4">
        <el-select class="margin-left-20px" placeholder="老师" size="medium" :disabled="loading" filterable v-model="searchCondition.teacherId" @change="onTeacherIdChange">
          <el-option v-for="item in termTeacherList" :key="item.Id" :label="item.Name" :value="item.Id" />
        </el-select>
      </el-col>
      <el-col :span="4" class="padding-left-20px">
        <el-checkbox size="medium" :disabled="loading" v-model="searchCondition.isVideoCourseRemoved" class="cs-isVideoCourseRemoved" @change="onisVideoCourseRemovedChange">去除视频课</el-checkbox>
      </el-col>
       <el-col :span="4" class="cs-signInQuery-buttons">
         <el-button type="primary" :disabled="loading" size="medium" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <el-row class="sign-table-container">
      <el-table max-height="700" :data="signInListData.SignInsSummaryCourseList" v-loading="loading" stripe style="width: 100%; " header-row-class-name="el-table-header">
        <el-table-column v-if="signInListData.SignInsSummaryCourseList.length > 0" prop="CourseName" label="课程" width="160" header-align="center" align="center" sortable fixed>
          <template slot-scope="scope">
            <span>{{scope.row.CourseName}}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(week, weekIndex) in signInListData.SignInsSummaryWeekList" :key="weekIndex" :label="`${week.WeekText} (出勤率)`" width="160" header-align="center" sortable
          :sort-by="row => row.SignInsSummaryWeekDataList.find(item => item.Week === week.Week).AttendRate">
          <template slot-scope="scope">
            <span>{{scope.row.SignInsSummaryWeekDataList.find(item => item.Week === week.Week).AttendRateText}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="signInListData.SignInsSummaryCourseList.length > 0" prop="AttendRate" label="总出勤率" min-width="150" header-align="center" align="center" sortable
          :sort-by="row => row.AttendRate">
          <template slot-scope="scope">
            <span>{{scope.row.AttendRateText}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import pagination from "@/components/common/pagination";

import { downloadFile } from "@/config/mUtils";
import { getTrainingTerms, getTermTeachers } from "@/service/common.service";
import {
  getSignInQueryListForTeacher,
  exportSignInQueryListByTeacher,
} from "@/service/signInManage.service";

const defaultValues = {
  signInListData: {
    SignInsSummaryWeekList: [],
    SignInsSummaryCourseList: []
  },
};

import { mixinSignInQuery } from "./mixinSignInQuery";
export default {
  name: "signInQueryList3",
  mixins: [mixinSignInQuery],
  components: {
    pagination,
  },
  props: {
    colOptions: {
      type: Object,
      default: function () {
        return {
          lgSize: 5,
          mdSize: 8,
          smSize: 24,
        };
      },
    },
    queryType: {
      type: String,
      required: true,
    },
    scPreloadData: {
      type: Object,
      default: () => {
        return {
          defaultValues: {},
          termList: [],
          universityGroups: [],
          trainingCourseCategories: [],
        };
      },
    },
    paginationOption: {
      typeof: Object,
      default: () => {
        return {
          displayPagination: false,
          hasEditButton: false,
          editButtonText: String.empty,
          hasAddButton: false,
          addButtonText: String.empty,
          hasSearch: false,
          editColumnTite: String.empty,
          showAcitveColor: true,
          hideDisableRow: true,
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      isDataReady: false,
      searchCondition: {
        courseType: 1,
        termId: null,
        groupNumber: null,
        trainingCourseCategory: null,
        trainingTermId: null,
        teacherId: null,
        isVideoCourseRemoved: false,
      },
      trainingTermList: [],
      termTeacherList: [],
      signInListData: defaultValues.signInListData,
    };
  },
  computed: {
    canExport() {
      if (this.queryType !== "3" || !this.isDataReady) return false;

      if (this.signInListData.SignInsSummaryCourseList.length === 0)
        return false;

      return true;
    },
  },
  methods: {
    async loadTrainingTermsFromServer() {
      if (
        this.queryType !== "3" ||
        this.searchCondition.courseType !==
          this.GLOBAL.courseType.vocationalTraining
      )
        return;

      let result = await getTrainingTerms(
        false,
        this.searchCondition.trainingCourseCategory
      );
      this.trainingTermList = !!result && result.success ? result.data : [];
      if (this.searchCondition._fromStore) return;

      let currentTerm = null;
      if (this.trainingTermList.length > 0) {
        currentTerm = this.trainingTermList.find((i) => i.IsCurrentTerm);
        if (!currentTerm) currentTerm = this.trainingTermList[0];
      }
      this.searchCondition.trainingTermId = !!currentTerm
        ? currentTerm.Id
        : null;
    },
    async loadTermTeachersFromServer() {
      if (this.queryType !== "3") return;

      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;

       let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : null;

      let result = await getTermTeachers(termId, groupNumber);
      this.termTeacherList = !!result && result.success ? result.data : [];
      if (this.searchCondition._fromStore) return;

      let currentTeacher = null;
      if (this.termTeacherList.length > 0) {
        currentTeacher = this.termTeacherList[0];
      }
      this.searchCondition.teacherId = !!currentTeacher
        ? currentTeacher.Id
        : null;
    },
    async loadSignInQueryListForTeacherFromServer() {
      if (this.queryType !== "3") return;

      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;
      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let teacherId = this.searchCondition.teacherId;

      if (!termId || !teacherId) {
        this.signInListData = defaultValues.signInListData;
        return;
      }

      this.loading = true;
      let result = await getSignInQueryListForTeacher(
        this.searchCondition.courseType,
        groupNumber,
        termId,
        teacherId,
        this.searchCondition.isVideoCourseRemoved
      );
      this.signInListData =
        !!result && result.success ? result.data : defaultValues.signInListData;
      this.updateSignInQueryAll({
        queryType: this.queryType,
        searchCondition: this.searchCondition
      });
      this.$set(this.searchCondition, "_fromStore", false);
      this.loading = false;
    },
    async exportSignInQueryListFromServer() {
      if (this.queryType !== "3") return;

      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;
      let courseType = this.searchCondition.courseType;
      let termId =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;

      if (!courseType || !termId) {
        this.signInListData = defaultValues.signInListData;
        return;
      }

      this.loading = true;
      let result = await exportSignInQueryListByTeacher(
        courseType,
        termId,
        groupNumber,
        this.searchCondition.trainingCourseCategory,
        this.searchCondition.teacherId,
        this.searchCondition.isVideoCourseRemoved
      );
      if (!!result && result.success) {
        downloadFile(result);
      }
      this.loading = false;
    },
    onCourseTypeChange() {
      this.$nextTick(async () => {
        await this.loadTrainingTermsFromServer();
        await this.loadTermTeachersFromServer();
      });
    },
    onGroupNumberChange() {
       this.$nextTick(async () => {
        await this.loadTermTeachersFromServer();
      });
    },
    onTermIdChange() {
      this.$nextTick(async () => {
        await this.loadTermTeachersFromServer();
      });
    },
    onTrainingCourseCategoryChange() {
      this.$nextTick(async () => {
        await this.loadTrainingTermsFromServer();
        await this.loadTermTeachersFromServer();
      });
    },
    onTrainingTermIdChange() {
      this.$nextTick(async () => {
        await this.loadTermTeachersFromServer();
      });
    },
    onTeacherIdChange() {
    },
    onisVideoCourseRemovedChange() {
    },
    onSearch(){
      this.loadSignInQueryListForTeacherFromServer();
    }
  },
  watch: {
    queryType(newValue, oldValue) {
      if (newValue == "3") {
        if (this.isDataReady) {
          this.updateSignInQueryAll({
            queryType: newValue,
            searchCondition: this.searchCondition,
          });
          return;
        } else {
          this.updateQueryType(newValue);
        }
      } else {
        return;
      }

      this.$nextTick(async () => {
        let storeSearchConditionValue = this.storeSearchCondition;
        if (!!storeSearchConditionValue) {
          this.searchCondition = storeSearchConditionValue;
          this.$set(this.searchCondition, "_fromStore", true);
        }

        await this.loadTrainingTermsFromServer();
        await this.loadTermTeachersFromServer();
        await this.loadSignInQueryListForTeacherFromServer();
        this.isDataReady = true;
      });
    },
    scPreloadData(newValue, oldValue) {
      Object.copy(
        this.searchCondition,
        { onlyFieldExists: true },
        newValue.defaultValues
      );

      if (this.queryType != "3") return;

      this.$nextTick(async () => {
        let storeSearchConditionValue = this.storeSearchCondition;
        if (!!storeSearchConditionValue) {
          this.searchCondition = storeSearchConditionValue;
          this.$set(this.searchCondition, "_fromStore", true);
        }

        await this.loadTrainingTermsFromServer();
        await this.loadTermTeachersFromServer();
        await this.loadSignInQueryListForTeacherFromServer();
        this.isDataReady = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-search-conditions {
  .el-col {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

.cs-isVideoCourseRemoved {
  line-height: 36px;
  margin-bottom: 0;
  margin-left: 5px;
}

.sign-table-container {
  margin-top: 10px;
}

.cs-signInQuery-buttons {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/signInManage/signInQueryList3.vue